module.exports = __webpack_public_path__ + "static/media/Coders-Crux.98758e1e.woff";